import { render, staticRenderFns } from "./public-discipline-card.vue?vue&type=template&id=a6388d60&scoped=true&"
import script from "./public-discipline-card.ts?vue&type=script&lang=ts&"
export * from "./public-discipline-card.ts?vue&type=script&lang=ts&"
import style0 from "./public-discipline-card.scss?vue&type=style&index=0&id=a6388d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6388d60",
  null
  
)

export default component.exports